import { render, staticRenderFns } from "./lkuCompanyuser.vue?vue&type=template&id=00cdb549"
import script from "./lkuCompanyuser.vue?vue&type=script&lang=js"
export * from "./lkuCompanyuser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports